/* src/app/shared/components/transaction/transaction.component.scss */
.max-height {
  height: 100%;
}
.form-input-invalid {
  color: red;
  font-weight: 300;
  font-style: italic;
  font-size: small;
}
.item-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-inline: 12px;
  margin-block: 24px;
}
.item-content .transaction-title-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.item-content .transaction-title-container > ion-icon {
  font-size: 10px;
}
.item-content .transaction-title-container .transaction-title {
  margin-left: 12px;
  font-size: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.item-content .transaction-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
}
.item-content .transaction-info .transaction-price {
  font-size: 14px;
  margin-left: 36px;
}
.item-content .transaction-info .transaction-price-credit {
  font-weight: bold;
  color: var(--ion-color-primary);
}
.item-content .transaction-info .transaction-category {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 15px;
  padding: 2px 5px;
}
.item-content .transaction-info .transaction-category .category-label {
  font-size: 14px;
  max-width: 120px;
  margin-right: 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
/*# sourceMappingURL=transaction.component.css.map */
